export default __webpack_public_path__ + "media/images/temporary/emily-1afeb49063af7675233bd3d1bf7a6902.jpg";